import IdManager from '../IdManager/index'

import constants from '../constants/index'

import utils from '../utils/index'

export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)
    }

    install() {
      super.install()
    }

    destroy() {
      super.destroy()
    }

    renderOneButton(dy) {
      let sizeOfSqure = 4
      return `
      <path
        pointer-events="none"
        d="M ${2 + sizeOfSqure} ${13 + dy - sizeOfSqure} h -${sizeOfSqure} v ${sizeOfSqure} h ${sizeOfSqure} v -${sizeOfSqure} L ${14 - sizeOfSqure} ${2 + dy + sizeOfSqure} h ${sizeOfSqure} v -${sizeOfSqure} h -${sizeOfSqure} v ${sizeOfSqure}"
        stroke="#000"
        fill="none"
        stroke-width="2"
      ></path>
      `
    }

    getlineButtons(shapeId) {
      let shape = this.shapes[shapeId]
        , shapeDef = this.getShapeDefByType(shape.type)
        , { meta: { lineButtonTypes } } = shapeDef

      return lineButtonTypes.map((type, i) => {
        let { name, style } = this.getLineDefByType(type)
          , dy = i * 18
        return `
          <rect 
          x="0" 
          y="${dy}"
          width="16" 
          height="16" 
          fill="none" 
          stroke="none" 
          pointer-events="bounding-box" 
          class="button pannable"
          data-action="add-line-${type}"
        >
          <title>${name}</title>
        </rect>
        ${this.renderOneButton(dy)}
        `
      }).join("")
    }

    getRemoveButton() {
      return `
        <rect 
        x="0" 
        y="0"
        width="16" 
        height="16" 
        fill="none" 
        stroke="none" 
        pointer-events="bounding-box" 
        class="button"
        data-action="remove-focus-object"
      >
        <title>删除</title>
      </rect>
      <path 
        d="M 2,2 L 13,13 M 13,2 L 2,13" 
        fill="none" 
        stroke="#000" 
        stroke-width="2"
        pointer-events="none"
      ></path>
      `
    }

    getButtons4Shape(shapeId) {

      let bbox = this.getShapeDefByType(this.shapes[this.focusObjectId].type).bbox
        , shape=this.shapes[this.focusObjectId]
        ,width=utils.isRectNode(shape)? utils.getTextLen(shape.name):bbox.width
        , outlinePadding = 5
        , matrixStr = `matrix(${this.shapes[this.focusObjectId].matrix.join(",")}) translate(-${bbox.x + width / 2}, -${bbox.y + bbox.height / 2})`
        , removeButtons = (constants.modeFilter.ShapeRemove & this.mode)
          ? this.getRemoveButton()
          : null
        , lineButtons = (constants.modeFilter.ShapeConnect & this.mode)
          ? removeButtons
            ? `<g transform="translate(0, 20)">${this.getlineButtons(this.focusObjectId)}</g>`
            : this.getlineButtons(this.focusObjectId)
          : ""

      return `
        <g 
          transform="${matrixStr} translate(${bbox.x + width + 2 * outlinePadding + 2}, ${bbox.y - outlinePadding})"
          visibility="${(!this.panningGroup) && (!this.ghostLine) ? "visible" : "hidden"}"
        >
          ${removeButtons}
          ${lineButtons}
        </g>
        `
    }

    getButtons4Line(lineId) {
      let bbox = this.getBBox(this.lines[this.focusObjectId].points)
        , outlinePadding = 5
        , removeButtons = (constants.modeFilter.LineRemove & this.mode)
          ? this.getRemoveButton()
          : null

      return `
        <g 
          transform="translate(${bbox.x + bbox.width + 2 * outlinePadding + 2}, ${bbox.y - outlinePadding})"
          visibility="${(!this.panningGroup) && (!this.ghostLine) ? "visible" : "hidden"}"
        >
          ${removeButtons}
        </g>
        `
    }

    getButtons4Point(lineId, index) {
      let { x, y } = this.lines[lineId].points[index]
        , bbox = { x: x - 5, y: y - 5, width: 10, height: 10 }
        , outlinePadding = 5
        , removeButtons = (constants.modeFilter.LinePan & this.mode)
          ? this.getRemoveButton()
          : null

      return `
        <g 
          transform="translate(${bbox.x + bbox.width + 2 * outlinePadding + 2}, ${bbox.y - outlinePadding})"
          visibility="${(!this.panningGroup) && (!this.ghostLine) ? "visible" : "hidden"}"
        >
          ${removeButtons}
        </g>
        `
    }

    display() {
      let buttons = ""
        , selectPath = this.selectPath ? `
          <path 
            d="${this.selectPath}Z"
            fill = "rgb(255, 116, 0)"
            fill-opacity = "0.1"
            stroke-dasharray = "5 1 3 1"
            stroke = "rgb(255, 116, 0)"
            shape-rendering = "crispEdges"
            pointer-events = "none"
          ></path>
        ` : ""

      if (this.focusObjectId in this.shapes) {
        // tools for a shape
        buttons = this.getButtons4Shape(this.focusObjectId)
      } else if (this.focusObjectId in this.lines) {
        buttons = this.getButtons4Line(this.focusObjectId)
      } else if (this.focusObjectId && this.focusObjectId.match(/^[^:]+:\d+/)) {
        let [lineId, index] = IdManager.split(this.focusObjectId)
        buttons = this.getButtons4Point(lineId, index)
      }

      return super.display() + `<g>${buttons} ${selectPath}</g>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/ToolLayerMixin.js